import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import './App.css';
import Header from "./components/Header/index.js";
import Footer from "./components/Footer/index.js";
import Homepage from "./pages/Homepage";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Error from "./pages/Error";
import Cart from "./pages/Cart";
import Contact from "./pages/Contact";
import Wishlist from "./pages/Wishlist";
import About from "./pages/About";
import Shop from "./pages/Shop";
import Blog from "./pages/Blog";
import Info from "./Info";
// import { motion, AnimatePresence, AnimateSharedLayout } from "framer-motion";

function App(props) {
  const location = useLocation();
  return (
    <div className="App">
        <Info />
        <div className="constructing">
          <Switch location={location} key={location.key}>
            
            <Route exact={true} path={["/", "/home", "/index"]}>
              <Header />
              <Homepage />
              <Footer />
              {/* {console.log(document.getElementById("header").clientHeight)} */}
            </Route>
            <Route path="/shop">
              <Header />
              <Shop />
              <Footer />
            </Route>
            <Route path="/blog">
              <Header />
              <Blog />
              <Footer />
            </Route>
            <Route path="/about">
              <Header />
              <About />
              <Footer />
            </Route>
            <Route path="/cart">
              <Header />
              <Cart />
              <Footer />
            </Route>
            <Route path="/contact">
              <Header />
              <Contact />
              <Footer />
            </Route>
            <Route path="/wishlist">
              <Header />
              <Wishlist />
              <Footer />
            </Route>
            <Route path="/signup">
              <Register />
            </Route>
            <Route path="/login">
              <Login />
            </Route>
            <Route component={Error} />
          </Switch>
        </div>
    </div>
  );
}

// Your web app's Firebase configuration
// var firebaseConfig = {
//   apiKey: "AIzaSyB13gkXL_w8ONiFKF904Bz42E3i4fvQJ1M",
//   authDomain: "tracemall-e-commerce.firebaseapp.com",
//   projectId: "tracemall-e-commerce",
//   storageBucket: "tracemall-e-commerce.appspot.com",
//   messagingSenderId: "29561664550",
//   appId: "1:29561664550:web:92dabaaf7a33b589a6a2e7"
// };
// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);

const matchStateToProps = (state) => {
  return {
    basket: state.basket
  }
}

export default connect(matchStateToProps)(App);
// import logo from './logo.svg';